/**
 * getLongList - returns array length 7 of items for large screens
 * getShortList - returns array length 5 of items for small screens
 * to render for page navigation
 *
 * @param {number} props.pages - number of pages to navigate through
 * @param {number} props.currentPage - current page
 * @returns {(number | undefined)[]} - array of page numbers to render
 */

const getLongList = ({ pages, currentPage }) => {
  const approachingFront = currentPage - 1 <= 3;
  const approachingEnd = pages - currentPage < 3;

  const secondItem = approachingFront ? 2 : undefined;
  const thirdItem = approachingFront ? 3 : currentPage - 1;

  const centered = !approachingEnd && !approachingFront;
  const centerItem = approachingEnd ? pages - 3 : 4;
  const fourthItem = centered ? currentPage : centerItem;
  const fifthItem = approachingEnd ? pages - 2 : fourthItem + 1;
  const sixthItem = approachingEnd ? pages - 1 : undefined;

  return [1, secondItem, thirdItem, fourthItem, fifthItem, sixthItem, pages];
};

const getShortList = ({ pages, currentPage }) => {
  const approachingFront = currentPage - 1 <= 2;
  const approachingEnd = pages - currentPage < 3;

  const secondItem = approachingFront ? 2 : undefined;
  const centered = !approachingEnd && !approachingFront;
  const centerItem = approachingEnd ? pages - 2 : 3;
  const thirdItem = centered ? currentPage : centerItem;
  const fourthItem = approachingEnd ? pages - 1 : undefined;

  return [1, secondItem, thirdItem, fourthItem, pages];
};

/**
 * getPagesToRender - returns final array of pages to render
 *
 * @param {number} props.pages - number of pages to navigate through
 * @param {number} props.currentPage - current page
 * @param {boolean} props.breakpointMet, - whether screen width breakpoint is met
 * @returns {(number | undefined)[]} - array of page numbers to render
 */

const getPagesToRender = ({ pages, currentPage, breakpointMet }) => {
  if (breakpointMet && pages <= 7) {
    return Array.from({ length: pages }, (_, i) => i + 1);
  }

  if (!breakpointMet && pages <= 5) {
    return Array.from({ length: pages }, (_, i) => i + 1);
  }

  switch (breakpointMet) {
    case true: {
      return getLongList({ pages, currentPage });
    }
    default: {
      return getShortList({ pages, currentPage });
    }
  }
};

export default getPagesToRender;
